
import { Table, TableBody } from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { TeacherReportTableHeader } from './salary/TeacherReportTableHeader';
import { TeacherReportTableRow } from './salary/TeacherReportTableRow';
import { ReportDetail } from '@/types/salary';

interface TeacherReportDetailsProps {
  reportDetails: ReportDetail[];
}

export function TeacherReportDetails({ reportDetails }: TeacherReportDetailsProps) {
  return (
    <Card>
      <div className="p-6">
        <h3 className="text-lg font-semibold mb-4">รายละเอียดรายงาน</h3>
        <div className="overflow-x-auto">
          <Table>
            <TeacherReportTableHeader />
            <TableBody>
              {reportDetails.map((report, index) => (
                <TeacherReportTableRow key={index} report={report} />
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </Card>
  );
}
